import { ToastContextDispatch } from "Context/CommonContext";
import ChapterContentTable from "Pages/MyLibrary/FacultyContent/ChapterContent/ChapterContentTable";
import { useContext, useEffect, useState } from "react";
import {
  BASE_URL,
  GET_CHAPTERCONTENTDATBYID,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import {
  FilterObject,
  filterArrayBasedOnObjectKeys,
  removeEmptyFields,
} from "utilFunctions/helperFunctions/HelperFunction";
export interface ChapterContentMainInferface {
  selectedChapter: any;
  courseId: any;
  setSelectedChapter?: any;
  togglePane?: any;
  module: any;
  isDrawerOpen: boolean;
  setIsDrawerOpen: any;
  filterDataValue: any;
  setFilterDataValue: any;
}
const ChapterContentMain = ({
  selectedChapter,
  courseId,
  module,
  filterDataValue,
  setFilterDataValue,
}: ChapterContentMainInferface) => {
  const fetchUrl = BASE_URL + GET_CHAPTERCONTENTDATBYID;
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [contentData, setContentData] = useState<any[]>([]);
  const [previousData, setPreviousData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 10,
    pageSizeOptions: ["10", "20", "50"],
    showSizeChanger: true,
    current: 1,
    sortField: "updatedAt",
    sortOrder: "DESC",
  });
  const { makeRequest: GetContentData, loading } = useGetApi(
    (data) => {
      if (data["data"] && data["data"].length > 0) {
        setContentData(data["data"]);
        setPagination({
          ...pagination,
          total: data["data"].length,
        });
        setPreviousData(data["data"]);
      } else {
        setContentData([]);
        setPreviousData([]);
      }
    },
    (error) => {
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      }
    }
  );
  useEffect(() => {
    if (selectedChapter != null) {
      setFilterDataValue({});
      setContentData([]);
      setCurrentPage(1);
      setItemsPerPage(10);
      const facultyContent = module === "studentContent" ? false : true;
      GetContentData(
        fetchUrl +
          `?facultyContent=${facultyContent}&chapterId=` +
          selectedChapter.id +
          "&courseId=" +
          courseId
      );
    }
  }, [selectedChapter, module]);
  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    const filters: FilterObject = removeEmptyFields(filterDataValue);
    console.log("filterDataValue===", filters);
    const filteredArray = filterArrayBasedOnObjectKeys(previousData, filters);
    setContentData(filteredArray);
    setPagination({
      ...pagination,
      total: filteredArray.length,
    });
    setCurrentPage(1);
    setItemsPerPage(10);
  }, [filterDataValue]);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const data = contentData.slice(indexOfFirstItem, indexOfLastItem);
  console.log("data====", data, selectedChapter);
  console.log("selectedChapterselectedChapter", selectedChapter);
  return (
    <>
      <ChapterContentTable
        pagination={pagination}
        setPagination={setPagination}
        data={data}
        loading={loading}
        courseId={courseId}
        setItemsPerPage={setItemsPerPage}
        onPageChange={handlePageChange}
      />
    </>
  );
};
export default ChapterContentMain;
